import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconVeriff.module.css';

const IconVeriff = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 25"
      width="60"
      height="25"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M59.64 14.28h-8.06c.19 1.93 1.6 2.55 3.2 2.55 1.64 0 2.96-.37 4.05-.95v3.32a8.33 8.33 0 0 1-4.56 1.1c-4.01 0-6.83-2.5-6.83-7.48 0-4.19 2.39-7.52 6.3-7.52 3.92 0 5.96 3.28 5.96 7.5 0 .4-.04 1.26-.06 1.48zm-5.92-5.62c-1.03 0-2.17.73-2.17 2.58h4.25c0-1.85-1.07-2.58-2.08-2.58zM40.95 20.3c-1.44 0-2.32-.6-2.9-1.04l-.02 4.63-4.12.87V5.57h3.76l.08 1.02a4.7 4.7 0 0 1 3.23-1.29c2.9 0 5.62 2.6 5.62 7.4 0 5.23-2.7 7.6-5.65 7.6zM40 9.01c-.95 0-1.54.34-1.97.81l.02 6.12c.4.44.98.78 1.95.78 1.52 0 2.54-1.65 2.54-3.87 0-2.15-1.04-3.84-2.54-3.84zM28.24 5.57h4.13v14.44h-4.13V5.57zm0-4.7L32.37 0v3.36l-4.13.88V.88zm-4.32 9.35v9.79H19.8V5.57h3.7l.12 1.22c1-1.77 3.07-1.41 3.62-1.22v3.79c-.52-.17-2.29-.43-3.32.86zm-8.55 4.72c0 2.43 2.6 1.68 3.12 1.46v3.36c-.55.3-1.54.54-2.89.54a4.15 4.15 0 0 1-4.27-4.24l.01-13.17 4.02-.86v3.54h3.14V9.1h-3.13v5.85zm-4.91.7c0 2.97-2.31 4.66-5.73 4.66-1.42 0-2.97-.27-4.5-.93v-3.93c1.38.75 3.13 1.31 4.5 1.31.93 0 1.6-.25 1.6-1.02 0-1.97-6.27-1.22-6.27-5.79 0-2.92 2.21-4.66 5.55-4.66 1.36 0 2.72.21 4.08.75v3.88a9.23 9.23 0 0 0-4.08-1.06c-.88 0-1.43.25-1.43.9 0 1.85 6.28.97 6.28 5.88z"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconVeriff.defaultProps = {
  className: null,
  rootClassName: null,
};

IconVeriff.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconVeriff;
